import React from "react";
import { Field, reduxForm } from "redux-form";
import { Link } from "react-router-dom";

import Button from "../../../../components/common/button/Button";
import Checkbox from "../../../../components/common/checkbox/Checkbox";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";
import Typeahead from "../../../../components/common/typeahead/Typeahead";
import { Form } from "react-bootstrap";
import { COMPANY_SIGNUP_FORM } from "../../../../actions/user.actions";
import {
  required,
  requiredFirstName,
  requiredLastName,
  alphaSymbolicSpace,
  minLength,
  email,
  dropdown
} from "../../../../utils/forms/validators";

import styles from "./SignUp.scss";

const alphaSymbolicSpaceValidation = msg => alphaSymbolicSpace(msg);

const firstName = alphaSymbolicSpaceValidation(
  "Please enter a valid first name."
);
const lastName = alphaSymbolicSpaceValidation(
  "Please enter a valid last name."
);
const emailVal = email("Please enter a valid email address.");
const password = minLength(8, "Password must be at least 8 characters.");
const referral = dropdown("Please select a Referral Type.");

const REFERRAL_FRIEND = 54;
const REFERRAL_TSS = 55;
// const REFERRAL_WEB = 56;
// const REFERRAL_PRESS = 57;
// const REFERRAL_LINKEDIN = 58;
const REFERRAL_SOCIAL = 59;
const REFERRAL_OTHER = 60;

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSelectInput: false,
      referralEdited: false,
      howHearPlaceholder: ""
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  getPlaceholderByValue(value) {
    switch (value) {
      case REFERRAL_FRIEND:
        return "Friend's Name";
      case REFERRAL_TSS:
        return "Referrer's Name";
      case REFERRAL_SOCIAL:
        return "Which social-media channel?";
      case REFERRAL_OTHER:
        return "Where'd you hear about us?";
      default:
        return `How'd you hear about us?`;
    }
  }

  handleSelect(value) {
    const showExtra =
      value == REFERRAL_FRIEND ||
      value == REFERRAL_TSS ||
      value == REFERRAL_SOCIAL ||
      value == REFERRAL_OTHER;

    this.props.change("referral_value", "");
    this.props.untouch("referral_value");

    this.setState({
      showSelectInput: showExtra,
      howHearPlaceholder: this.getPlaceholderByValue(value),
      referralEdited: true
    });
  }

  render() {
    const { invalid, submitting, pristine } = this.props;

    const referralsPlaceholder = this.state.referralEdited
      ? null
      : "How'd you hear about us?";

    return (
      <section className={styles.employerSignUp}>
        <div className={styles.content}>
          <h2 className={styles.title}>Create Your Company Account</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <div className={styles.subtitle}>
                <span>
                  Looking for Projects? Go to&nbsp;
                  <Link to="/member/sign-up">Member signup</Link>
                  &nbsp;instead.
                </span>
              </div>

              <Field
                name="first_name"
                type="text"
                placeholder="First Name"
                component={Input}
                validate={[requiredFirstName, firstName]}
                autoFocus={true}
              />

              <Field
                name="last_name"
                type="text"
                placeholder="Last Name"
                component={Input}
                validate={[requiredLastName, lastName]}
              />

              <Field
                name="email"
                type="text"
                placeholder="Email Address"
                component={Input}
                validate={[required, emailVal]}
              />

              <Field
                allowNew={true}
                component={Typeahead}
                id="company"
                isAsync={true}
                isLoading={this.props.isLoading}
                labelKey="name"
                minLength={3}
                name="company"
                newSelectionPrefix="Add new company: "
                placeholder="Company"
                options={this.props.companies}
                validate={[required]}
                valueKey="id"
                focusOut={(query, selected) => {
                  if (!selected) {
                    this.props.change("company", null);

                    if (query) {
                      this.props.change("company[0].customOption", true);
                      this.props.change("company[0].name", query);
                    }
                  }
                }}
                onSearch={query => this.props.onSearchCompanies(query)}
              />

              <Field
                name="password"
                type="password"
                placeholder="Account Password"
                component={Input}
                validate={[required, password]}
                showPasswordIcon
                autoComplete="off"
              />

              <Field
                name="referral_type"
                type="select"
                placeholder={referralsPlaceholder}
                component={Select2}
                options={this.props.referrals}
                onSelectChange={this.handleSelect}
                validate={[required, referral]}
              />

              {this.state.showSelectInput && (
                <Field
                  name="referral_value"
                  type="text"
                  placeholder={this.state.howHearPlaceholder}
                  component={Input}
                  validate={[required]}
                />
              )}

              <div className={styles.dividerDouble} />

              <label className={styles.termsCheckbox}>
                <Field name="terms" component={Checkbox} signUp={true} />
                <span className={styles.checkboxText}>
                  I agree to The Second Shift{" "}
                  <Link to="https://www.thesecondshift.com/tos" target="_blank">
                    Terms of Service
                  </Link>{" "}
                  and&nbsp;
                  <Link
                    to="https://www.thesecondshift.com/privacy"
                    target="_blank"
                  >
                    Privacy Policy.
                  </Link>
                </span>
              </label>

              <p className={styles.error}>{this.props.checkboxError}</p>

              <Button
                relative
                isDisabled={invalid || submitting || pristine}
                isPrimary
                type="submit"
                size="large"
                label="Create Company Account"
              />
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

export default (SignUp = reduxForm({
  form: COMPANY_SIGNUP_FORM,
  enableReinitialize: true,
  touchOnChange: true
})(SignUp));



// WEBPACK FOOTER //
// ./src/routes/employer/signUp/components/SignUp.js